if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"home-frontend","remotes":[{"alias":"@sravni/mf-search","name":"scope_sravni__mf_search","entry":"https://s81616.cdn.ngenix.net/mf/@sravni/mf-search/client/mf-manifest.json","shareScope":"default"}],"shareStrategy":"loaded-first"},
		chunkMatcher: function(chunkId) {return 483 != chunkId},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}